<template>
    <div class="container">
        <div id="datepicker"></div>
        <h1>Test</h1>
    </div>
</template>

<script>
    export default {
        name: "datepicker",
        data() {
            return {

            }
        },
        mounted() {
            $( "#datepicker" ).datepicker();
            console.log($('#datepicker'));
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/datepicker.vue